import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';
import { resources } from './locales/resources';

i18n
  .use(LanguageDetector)
  .use(intervalPlural)
  .use(initReactI18next)
  .init({
    resources,
    /* lng: "en-US", */
    supportedLngs: ['en-US', 'hu-HU'],
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
});

export default i18n;
